import React from 'react';
import { Button } from '@/components/ui/button';
import { getMonthRangeISO } from '@/lib/utils';

/** This/Last/Next month shortcuts shared by every Sales Invoicing date-range filter. */
export default function MonthShortcuts({ onSelect, testIdPrefix }) {
  const apply = (offset) => {
    const { from, to } = getMonthRangeISO(offset);
    onSelect(from, to);
  };
  return (
    <div className="flex items-center gap-1.5">
      <Button type="button" size="sm" variant="outline" onClick={() => apply(-1)} data-testid={`${testIdPrefix}-last-month-btn`}>Last month</Button>
      <Button type="button" size="sm" variant="outline" onClick={() => apply(0)} data-testid={`${testIdPrefix}-this-month-btn`}>This month</Button>
      <Button type="button" size="sm" variant="outline" onClick={() => apply(1)} data-testid={`${testIdPrefix}-next-month-btn`}>Next month</Button>
    </div>
  );
}
